import moment from "moment";
export function apply() {
  // eslint-disable-next-line no-extend-native
  Date.prototype.toJSON = function () {
    return moment(this).format("YYYY-MM-DDThh:mm:ss");
  };
}
